/**
 * Assets do landing legado (HubSpot report.fius.com.br) — banners por slug.
 * URLs públicas no CDN FIUS; novos clientes podem acrescentar entrada ou usar env.
 */

const HUBFS = 'https://report.fius.com.br/hs-fs/hubfs';

/** Logo branco para faixa escura (como no site legado). */
export const FIUS_LOGO_NEGATIVO_BRANCO_URL = `${HUBFS}/FIUS_LOGO_negativo_branco_PNG24_web.png?width=280&name=FIUS_LOGO_negativo_branco_PNG24_web.png`;

/**
 * Banner padrão do portal público — imagem em `frontend/public/images/` (versionada no Git).
 * CRA expõe em `${PUBLIC_URL}/images/portal-banner-fius.png`.
 */
export const DEFAULT_PUBLIC_PORTAL_BANNER_URL = `${process.env.PUBLIC_URL || ''}/images/portal-banner-fius.png`;

/** Overrides por slug (opcional). Sem entrada → banner padrão local em `/images/portal-banner-fius.png`. */
const BANNER_BY_SLUG = {};

/**
 * Ordem: URL no formulário (API) → env → mapa por slug → banner padrão FIUS (sempre há imagem).
 * Para desativar o banner e usar o hero Nexus: REACT_APP_PUBLIC_HERO_NEXUS=true
 *
 * @param {string} [clientSlug]
 * @param {string} [envBanner] REACT_APP_PORTAL_BANNER_URL
 * @param {string} [formBannerUrl] portal_banner_url vindo do backend (opcional)
 * @returns {string|undefined}
 */
export function resolvePortalBannerUrl(clientSlug, envBanner, formBannerUrl) {
  const forceNexus =
    typeof process !== 'undefined' && process.env.REACT_APP_PUBLIC_HERO_NEXUS === 'true';
  if (forceNexus) return undefined;

  if (formBannerUrl && String(formBannerUrl).trim()) return String(formBannerUrl).trim();
  if (envBanner && String(envBanner).trim()) return String(envBanner).trim();
  if (clientSlug) {
    const key = clientSlug.toLowerCase().trim();
    if (BANNER_BY_SLUG[key]) return BANNER_BY_SLUG[key];
  }
  return DEFAULT_PUBLIC_PORTAL_BANNER_URL;
}
